export enum Sentiment {
    all = 0,
    question = 1,
    praise = 2,
    suggestion = 3,
    complaint = 4,
}
